import { render, staticRenderFns } from "./RelatieImportStatus.vue?vue&type=template&id=60b61ba0"
import script from "./RelatieImportStatus.vue?vue&type=script&lang=js"
export * from "./RelatieImportStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports